import React, { FC, useState, useMemo, useEffect, useCallback, useRef } from 'react';
import { useHistory, useLocation, useParams, useRouteMatch } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import styled, { useTheme } from 'styled-components';
import {
  FlexBox,
  useIsMobile,
  useBreakpoint,
  BLangSwitcher,
  NavbarButtonFilled, RectangularButtonFilled, Colors, useToasts,
} from '@brg/ui';
import { Competition, Team } from "@brg/api";

import { NavBar, NavbarWidget } from 'shared/components/__FOX__/NAV/src';
import { CreateLinkTo, LinkTo } from 'shared/constants/linkTo';
import { BacklogModalView } from 'shared/components/backlog';
import { useAuth } from 'core/hooks/auth/useAuth';
import useSingleTagModal from "../hooks/useSingleTagModal";
import { AppTester } from 'supporting';
import { ProfileRole, bProfile } from '@brg/auth';
import { RectangularButtonHollow } from "../components/buttons";
import { SaveUserLang } from "../components/__ADDONS__/__LANG__/Utils/GetUserLang";
import { setAppLang } from "../components/__ADDONS__/__LANG__/Slice";
import { useDispatch, useSelector } from 'react-redux';
import DeziignNavBarMobile from './DeziignNavBarMobile';
import { LayoutConst } from 'core/modules';
import { DropdownWithExternalsLinks } from './components/contextTabsItems';
import ViewTypeControllerWide from "../components/ViewTypeControllerWide/ViewTypeControllerWide";
import { useContextsTabs } from 'shared/hooks/useContextsTabs';
import { HseContextSelector } from 'shared/reducers/hseCurrentContext';
import { ORGANIZATION_LIST, COURSE_LIST } from 'shared/hooks/useGetCurrentTeam';
import NotificationsController from "../components/NotificationsController/NotificationsController";
import { CommdesignNavbar } from './CommdesignNavbar';
import { useNotificationContext } from "../contexts/NotificationContext";
import { MainSearchButton } from 'shared/components/MainSearchController/MainSearchButton';
import AnchorNavigation from "../components/AnchorNavigation";
import useExternalOrganization from "../pages/exploreHseContextsNew/useExternalOrganization";
import { ModerationType } from "../pages/teams/const/ModerationTypes";
import useQueryState from 'shared/hooks/useQueryState';
import { HsePolicies } from 'shared/constants/HsePolicies';
import FeedButton from "../components/NotificationsController/FeedButton";
import { useProject } from 'shared/hooks/api/useProject';
import i18next from 'i18next';
import { PhoneText } from "../components/TeamInfo/TeamInfo";
import useSplitTagsConfig from "../hooks/useSplitTagsConfig";
import { useGetFilteredTabs } from "../components/navigationSystem/useGetFilteredTabs";
import { useGetLogo } from 'shared/components/navigationSystem/useGetLogo';
import { getShouldDisplaySearch } from "../helpers/getShouldDisplaySearch";
import { Input } from '@brg/input';
import { ProjectEditPageGridInput } from "_deziiign/books/pages/BookEdit/styles";
import urlApi from 'shared/actions/urlApi';
import ChannelButton from 'shared/components/NotificationsController/ChannelButton';
import { NavbarSearchActions } from "shared/reducers/NavbarSearch";
import WidgetLogin from './WidgetLogin';
import { useChannelsContext } from 'shared/contexts/ChannelsContext';
import { hasDefaultChannel, hasPersonalChannel } from 'shared/helpers/teamsStatus';
import { useGetFeedInfo } from 'shared/hooks/api/useGetFeedInfo';
import { ChapterPager } from './components/ChapterPager';
import useNavbarSettings from 'shared/hooks/useNavbarSettings';
import CreatePresentationButton from './components/CreatePresentationButton';

const ADD_WIDTH_FOR_HSEMAIN_LAYOUT = 50;
const ADD_WIDTH_FOR_LMS_LAYOUT = 150;

/**
 * # Hsedesign main menu
 */
interface MenueProps {
  className?: any;
}

export const Burger = styled(FlexBox)`
  height: 40px;
  align-items: center;
  opacity: 0.73;
  transition: all 0.2s;

  &:hover {
    opacity: 1;
  }
`;

export const LangContainer = styled(FlexBox)`
  //padding-left: 24px;
  //@media (min-width: 1440px) {
  //  padding-left: 37px;
  //}
  // @media(max-width: 1024px) {
  //   position: absolute;
  //   top: 50%;
  //   left: 50%;
  //   transform: translate(-50%, -50%);
  //   padding: 0;
  //   margin: 0 auto;
  // }
`;

export const DropdownWrapper = styled(FlexBox)`
  margin-left: 16px;

  @media (max-width: ${LayoutConst.screen.l_16}px) {
    margin-left: 4px;
  }

  @media (max-width: 940px) {
    margin-left: 0;
  }

  @media (max-width: 568px) {
    margin-left: 0;
  }
`;

export const HSEDeziignNavBar: FC<MenueProps> = () => {
  const auth = useAuth();
  const location = useLocation();
  const { t, i18n } = useTranslation();
  const history = useHistory();
  const theme = useTheme();
  const [visibleError, setVisibleError] = useState(false);
  const [{ mainBookId }] = useQueryState();
  const isSchool = AppTester.isSchool();
  const isProjectPreview = useRouteMatch<{ id: string }>("/preview/:id");
  const isCompetition = useRouteMatch<{ id: string }>("/competition/:id");
  const isBookPreview = useRouteMatch<{ id: string }>("/books/book-preview/:id");
  const isBookProjectPreview = useRouteMatch<{ id: string }>("/books/preview/:id");
  const isTeamPreview = useRouteMatch<{ id: string }>('/team-preview/:id');
  const isTeamLgPreview = useRouteMatch<{ id: string }>('/team-longread-preview/:id');
  const isCommdesign = location.pathname.startsWith("/school/commdesign") && AppTester.isSchool()
  const { teamName } = useParams<{ teamName: string }>();
  const isProfilePage = !!useRouteMatch("/designer");
  const isHSEMain = AppTester.isContext('hsedesign')
  const shouldNotSaveTeam = useMemo(() => isProfilePage && isHSEMain, [isProfilePage, isHSEMain])

  const team = useExternalOrganization(teamName, false, shouldNotSaveTeam) as Team | undefined;
  const MainLogo = useGetLogo({});

  const isChapterPreview = useMemo(() => (!!mainBookId && !!isBookProjectPreview), [mainBookId, isBookProjectPreview])

  const isLMS = AppTester.isLMSHSE() || team?.moderationType == ModerationType.LMS;

  const isBooks = !!useRouteMatch([LinkTo.hseBooks, '/hsebooks']);

  const profile = auth.token ? auth.associatedProfile : undefined;

  const isMobile = useIsMobile();
  const isTablet = useBreakpoint(1200);
  const toasts = useToasts()
  const isCompetitions = location.pathname.startsWith(LinkTo.awards);
  const isHseColors = AppTester.isHseColors();
  const isModer = useMemo(() => profile && bProfile.isModer(profile), [profile]);

  const [isFlexBoxEmpty, setIsFlexBoxEmpty] = useState(true);

  const {
    shouldDisplayCreateButton,
    shouldDisplayProDropdown,
    shouldDisplayChannelButton,
    shouldDisplayFeedButton,
    shouldDisplayLangSwitcher,
    shouldDisplayEditorInterface,
    shouldDisplayNotifications,
    createButtonTitle,
    onLangSwitch,
  } = useNavbarSettings();

  const shouldDisplaySearch = getShouldDisplaySearch()

  const isBriefModer = profile && profile.rolesList && Array.isArray(profile.rolesList)
    && (new ProfileRole(HsePolicies.access_brief_competitions)).containsIn(profile.rolesList);

  const isCompetitionModer = profile && profile.rolesList && Array.isArray(profile.rolesList)
    && (new ProfileRole(HsePolicies.access_competitions)).containsIn(profile.rolesList);

  if (shouldDisplayEditorInterface) {
    return null;
  }

  if (isCommdesign) return <CommdesignNavbar />

  if ((isMobile || isTablet)) {
    return <DeziignNavBarMobile />
  }

  const getHeaderNavLayout = (isCompetition: any, isSchool?: boolean, isFlexBoxEmpty?: boolean) => {
    if (isCompetition) {
      return <SectionCompetition isFlexBoxEmpty={isFlexBoxEmpty} key={'section-d'} />
    } else if (isSchool) {
      return <SectionSchool key={'section-d'} />
    } else {
      return <SectionDeziign team={team} isFlexBoxEmpty={isFlexBoxEmpty} key={'section-d'} />
    }
  }

  return (
    <NavBar
      errorComponent={visibleError && <BacklogModalView onExit={() => setVisibleError(false)} />}
      theming={{
        zIndex: 99999,
        backgroundColor: theme.navigationBar.backgroundColor,
        borderBottomColor: theme.navigationBar.borderBottomColor,
        backgroundScrolling: theme.navigationBar.backgroundScrollingColor,
        boxShadow: theme.navigationBar.boxShadow,
      }}
      logo={MainLogo}
      onLogoClick={() => {
        if (isProjectPreview) return

        window.location.href = '/'
      }}
      sections={[
        [getHeaderNavLayout(isCompetition, isSchool, isFlexBoxEmpty)],
        [
          <ChapterPager />,
          <ViewTypeControllerWide />,
          ...(shouldDisplaySearch ? [
            <MainSearchButton />
          ] : []),
          ...(isHseColors ? [
            <FlexBox offsetRight={isMobile ? 16 : 0}>
              <RectangularButtonFilled onClick={() => navigator.clipboard.writeText('79999999999').then(() => toasts.info(t && t('phone_copied')))}>
                <PhoneText style={{ color: Colors.geoWhite100 }}>
                  +7 999 999 99-99
                </PhoneText>
              </RectangularButtonFilled>
            </FlexBox>
          ] : []),
          ...(shouldDisplayNotifications) ? [
            <NotificationsController />,
            ...(shouldDisplayChannelButton ? [<ChannelButton />] : []),
            ...(shouldDisplayFeedButton ? [<FeedButton />] : []),
          ] : [],
          ...(shouldDisplayLangSwitcher ?
            [
              <LangContainer>
                <BLangSwitcher
                  currentLanguage={i18n.language}
                  onLangSelect={onLangSwitch}
                  key="lang"
                />
              </LangContainer>
            ] :
            []),

          ...((isProjectPreview || isBookPreview || isBookProjectPreview || isTeamPreview || isTeamLgPreview) ?
            [<FlexBox key="button-widget" align="center">
              <RectangularButtonHollow
                onClick={() => {
                  if (isChapterPreview && isBookProjectPreview?.params?.id) {
                    history.push(`/books/book-edit/${(mainBookId ?? 'undefined')}`)
                    return;
                  }
                  if (isProjectPreview?.params?.id)
                    history.push(CreateLinkTo.projectEdit(isProjectPreview?.params?.id ?? 'undefined'))
                  if (isBookPreview?.params?.id)
                    history.push(CreateLinkTo.bookEdit(isBookPreview?.params?.id ?? 'undefined'))
                  if (isBookProjectPreview?.params?.id)
                    history.push(CreateLinkTo.bookProjectEdit(isBookProjectPreview?.params?.id ?? 'undefined'))
                  if (isTeamPreview?.params?.id)
                    history.push(CreateLinkTo.teamEdit(isTeamPreview?.params?.id ?? 'undefined'))
                  if (isTeamLgPreview?.params?.id)
                    history.push(CreateLinkTo.teamEdit(isTeamLgPreview?.params?.id ?? 'undefined') + '?tab=lg')
                }
                }
              >
                {t("nav.exit_preview") ?? "Exit"}
              </RectangularButtonHollow>
            </FlexBox>
            ] :
            shouldDisplayCreateButton ? [<FlexBox
              key={'button-widget'} align={'center'}>
              {shouldDisplayProDropdown ? (
                <CreatePresentationButton />
              ) : (
                <NavbarButtonFilled
                  style={{ padding: '6px 24px', minWidth: 'auto', maxWidth: 'max-content', whiteSpace: 'nowrap', fontWeight: 700 }}
                  onClick={() => {
                    if (isCompetitions && (isModer || isBriefModer || isCompetitionModer)) {
                      history.push(CreateLinkTo.competitionCreate());
                    } else if (isBooks) {
                      history.push(CreateLinkTo.bookCreate());
                    } else if (isLMS) {
                      // @ts-ignore
                      history.push(CreateLinkTo.projectCreateByOrganization(team?.contextName));
                    } else {
                      history.push(CreateLinkTo.projectCreate());
                    }
                  }}
                >
                  {createButtonTitle ?? 'create'}
                </NavbarButtonFilled>
              )}
            </FlexBox>] : []),
          ...(isHseColors ? [] : [<WidgetLogin />]),
        ],
      ]}
    />
  );
};
// @ts-ignore
const SectionCompetition = ({ isFlexBoxEmpty }) => {
  const theme = useTheme();
  const isHseMain = AppTester.isContext('hsedesign');

  const isLMS = AppTester.isLMSHSE();
  const isStartHSE = AppTester.isStartHSE();
  const isProHse = AppTester.isProHSE();
  const is1600 = useBreakpoint(LayoutConst.screen.l_16 + ADD_WIDTH_FOR_HSEMAIN_LAYOUT);
  const isLmsSize = useBreakpoint(LayoutConst.screen.l_16 + ADD_WIDTH_FOR_LMS_LAYOUT);
  const isMac13ForHSEMAIN = useBreakpoint(LayoutConst.screen.mac13 + ADD_WIDTH_FOR_HSEMAIN_LAYOUT);
  const isFullHD = useBreakpoint(1920);
  const is1280 = useBreakpoint(LayoutConst.screen.l_12);
  const isSamokat = useRouteMatch("/samokat");

  const shouldDisplayDotsDropdown = useMemo(
    () => {
      if ((isLMS || isStartHSE) && isLmsSize) {
        return true;
      }
      if (isStartHSE && isFullHD) {
        return true;
      }
      return ((isHseMain || isProHse || isSamokat || isStartHSE) && is1600) || (!isFlexBoxEmpty && isFullHD)
    }
    , [isHseMain, is1600, isProHse, isLmsSize, isLMS, isFullHD, isFlexBoxEmpty, isSamokat, isStartHSE])

  const currentCutTabs = useMemo(() => {
    if ((isHseMain || isProHse || isSamokat || isStartHSE) && is1280) return 4;
    else if ((isHseMain || isProHse || isSamokat || isStartHSE) && is1600) return 5;
    else if ((isLMS || isStartHSE) && isMac13ForHSEMAIN) return 4;
    // else if (is1600) return 3;
    return 4;
  }, [isHseMain, isProHse, isSamokat, isMac13ForHSEMAIN, is1280, isLMS, is1600, isStartHSE])

  const fullUrls = useGetFilteredTabs()

  const formatForExternalLinks = fullUrls.slice(currentCutTabs).map(item => {
    return {
      active: item.active,
      ctx: "",
      external: item.external,
      isTeam: false,
      disabled: item.disabled,
      name: item.linkTo,
      title: item.content,
      value: item.linkTo
    }
  })

  const items = useMemo(() => {
    if (((isHseMain || isLMS || isProHse || isSamokat || isStartHSE) && is1600) || (isStartHSE && isFullHD)) {
      return fullUrls.slice(0, currentCutTabs)
    } else if ((isLMS || isStartHSE) && isLmsSize) {
      return fullUrls.slice(0, currentCutTabs)
    } else if ((isFlexBoxEmpty && !(isStartHSE && isFullHD)) || !isFullHD) {
      return fullUrls
    }

    return fullUrls.slice(0, currentCutTabs)
  }, [isHseMain, isMac13ForHSEMAIN, isProHse, isLMS, isSamokat, is1600, currentCutTabs, fullUrls, isFullHD, isFlexBoxEmpty, isStartHSE, isLmsSize])

  return (
    <>
      <NavbarWidget.Links
        key={'links-widget'}
        items={items}
        theming={theme.navigationBar.links}
      />
      {shouldDisplayDotsDropdown && !!formatForExternalLinks?.length && (
        <DropdownWrapper>
          <DropdownWithExternalsLinks
            maxHeight={460}
            maxWidth={400}
            list={formatForExternalLinks}
            initialTab={''}
            hoverOpen
          />
        </DropdownWrapper>
      )}
    </>
  );
}

// @ts-ignore
const SectionDeziign = ({ team, isFlexBoxEmpty }) => {
  const theme = useTheme();
  const is1280 = useBreakpoint(LayoutConst.screen.l_12);
  const isFullHD = useBreakpoint(1920);
  const is1600 = useBreakpoint(LayoutConst.screen.l_16 + ADD_WIDTH_FOR_HSEMAIN_LAYOUT);
  const isMac13ForHSEMAIN = useBreakpoint(LayoutConst.screen.mac13 + ADD_WIDTH_FOR_HSEMAIN_LAYOUT);
  const isLmsSize = useBreakpoint(LayoutConst.screen.l_16 + ADD_WIDTH_FOR_LMS_LAYOUT);
  const { anchorsOverrideNavigation } = useSelector(HseContextSelector);

  const isProHse = AppTester.isProHSE();
  const isHseMain = AppTester.isContext('hsedesign');
  const isExams = AppTester.isExamHSE();
  const isSamokat = useRouteMatch("/samokat");
  const isLMS = AppTester.isLMSHSE();
  const isStartHSE = AppTester.isStartHSE();
  const isBooks = !!useRouteMatch([LinkTo.hseBooks, '/hsebooks']);

  const fullUrls = useGetFilteredTabs()

  const shouldDisplayDotsDropdown = useMemo(
    () => {
      if (((isLMS || isStartHSE || isExams) && isLmsSize) || (!isFlexBoxEmpty && isFullHD)) {
        return true;
      }
      if (isStartHSE && isFullHD) {
        return true;
      }

      return ((isHseMain || isProHse || isSamokat || isStartHSE || isExams) && is1600) || (!isFlexBoxEmpty && isFullHD)
    }
    , [isHseMain, is1600, isProHse, isLMS, isLmsSize, isFullHD, isFlexBoxEmpty, isExams, isSamokat, isStartHSE])

  const currentCutTabs = useMemo(() => {
    if (isBooks && isMac13ForHSEMAIN) return 3;
    else if (isBooks && is1600) return 4;
    else if ((isLMS || isStartHSE) && (isMac13ForHSEMAIN || isLmsSize)) return 4;
    else if (isLMS) return 7;
    else if (isStartHSE && isFullHD) return 4;
    else if (isStartHSE) return 8;
    else if (isExams && isMac13ForHSEMAIN) return 3
    else if ((isHseMain || isProHse || isSamokat || isStartHSE || isExams) && is1280) return 4;
    else if ((isHseMain || isProHse || isSamokat || isStartHSE || isExams) && is1600) return 5;
    // else if (is1600) return 3;
    return 4;
  }, [isHseMain, isProHse, isSamokat, isExams, isLmsSize, isBooks, isMac13ForHSEMAIN, is1280, isLMS, is1600, isStartHSE, isFullHD])


  const formatForExternalLinks = fullUrls.slice(currentCutTabs).map(item => {
    return {
      active: item.active,
      action: item.action,
      ctx: "",
      external: item.external,
      isTeam: false,
      isModal: true,
      disabled: item.disabled,
      name: item.linkTo,
      title: item.content,
      value: item.linkTo
    }
  })

  const items = useMemo(() => {
    if (((isHseMain || isProHse || isSamokat || isStartHSE || isExams) && is1600) || (isStartHSE && isFullHD)) {
      return fullUrls.slice(0, currentCutTabs)
    } else if ((isLMS || isStartHSE || isExams) && isLmsSize) {
      return fullUrls.slice(0, currentCutTabs)
    }
    else if ((isFlexBoxEmpty && !(isStartHSE && isFullHD)) || !isFullHD) {
      return fullUrls
    }

    return fullUrls.slice(0, currentCutTabs)
  }, [isHseMain, isMac13ForHSEMAIN, isProHse, isExams, isLmsSize, isLMS, isSamokat, is1600, currentCutTabs, fullUrls, isFullHD, isFlexBoxEmpty, isStartHSE])


  if (anchorsOverrideNavigation) {
    return <AnchorNavigation />
  }

  return (
    <>
      <NavbarWidget.Links
        key="links-widget"
        theming={theme.navigationBar.linksHse}
        items={items}
      />
      {shouldDisplayDotsDropdown && !!formatForExternalLinks?.length && (
        <DropdownWrapper>
          <DropdownWithExternalsLinks
            maxHeight={460}
            maxWidth={400}
            list={formatForExternalLinks}
            initialTab={''}
            hoverOpen
          />
        </DropdownWrapper>
      )}
    </>
  );
};


const SectionSchool = () => {
  const theme = useTheme();
  const items = useGetFilteredTabs()

  return (
      <NavbarWidget.Links
        key="links-widget"
        theming={theme.navigationBar.linksHse}
        items={items}
      />
  );
};
import React, { FC, useState, useMemo, useEffect, useCallback, useRef } from 'react';
import { useHistory, useLocation, useParams, useRouteMatch } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import styled, { useTheme } from 'styled-components';
import {
  FlexBox,
  useIsMobile,
  useBreakpoint,
  BLangSwitcher,
  NavbarButtonFilled, RectangularButtonFilled, Colors, useToasts,
} from '@brg/ui';
import { Competition, Team } from "@brg/api";

import { NavBar, NavbarWidget } from 'shared/components/__FOX__/NAV/src';
import { CreateLinkTo, LinkTo } from 'shared/constants/linkTo';
import { BacklogModalView } from 'shared/components/backlog';
import { useAuth } from 'core/hooks/auth/useAuth';
import useSingleTagModal from "../hooks/useSingleTagModal";
import { AppTester } from 'supporting';
import { ProfileRole, bProfile } from '@brg/auth';
import { RectangularButtonHollow } from "../components/buttons";
import { SaveUserLang } from "../components/__ADDONS__/__LANG__/Utils/GetUserLang";
import { setAppLang } from "../components/__ADDONS__/__LANG__/Slice";
import { useDispatch, useSelector } from 'react-redux';
import DeziignNavBarMobile from './DeziignNavBarMobile';
import { LayoutConst } from 'core/modules';
import { DropdownWithExternalsLinks } from './components/contextTabsItems';
import ViewTypeControllerWide from "../components/ViewTypeControllerWide/ViewTypeControllerWide";
import { useContextsTabs } from 'shared/hooks/useContextsTabs';
import { HseContextSelector } from 'shared/reducers/hseCurrentContext';
import { ORGANIZATION_LIST, COURSE_LIST } from 'shared/hooks/useGetCurrentTeam';
import NotificationsController from "../components/NotificationsController/NotificationsController";
import { CommdesignNavbar } from './CommdesignNavbar';
import { useNotificationContext } from "../contexts/NotificationContext";
import { MainSearchButton } from 'shared/components/MainSearchController/MainSearchButton';
import AnchorNavigation from "../components/AnchorNavigation";
import useExternalOrganization from "../pages/exploreHseContextsNew/useExternalOrganization";
import { ModerationType } from "../pages/teams/const/ModerationTypes";
import useQueryState from 'shared/hooks/useQueryState';
import { HsePolicies } from 'shared/constants/HsePolicies';
import FeedButton from "../components/NotificationsController/FeedButton";
import { useProject } from 'shared/hooks/api/useProject';
import i18next from 'i18next';
import { PhoneText } from "../components/TeamInfo/TeamInfo";
import useSplitTagsConfig from "../hooks/useSplitTagsConfig";
import { useGetFilteredTabs } from "../components/navigationSystem/useGetFilteredTabs";
import { useGetLogo } from 'shared/components/navigationSystem/useGetLogo';
import { getShouldDisplaySearch } from "../helpers/getShouldDisplaySearch";
import { Input } from '@brg/input';
import { ProjectEditPageGridInput } from "_deziiign/books/pages/BookEdit/styles";
import urlApi from 'shared/actions/urlApi';
import ChannelButton from 'shared/components/NotificationsController/ChannelButton';
import { NavbarSearchActions } from "shared/reducers/NavbarSearch";
import WidgetLogin from './WidgetLogin';
import { useChannelsContext } from 'shared/contexts/ChannelsContext';
import { hasDefaultChannel, hasPersonalChannel } from 'shared/helpers/teamsStatus';
import { useGetFeedInfo } from 'shared/hooks/api/useGetFeedInfo';
import { ChapterPager } from './components/ChapterPager';
import useNavbarSettings from 'shared/hooks/useNavbarSettings';
import CreatePresentationButton from './components/CreatePresentationButton';

const ADD_WIDTH_FOR_HSEMAIN_LAYOUT = 50;
const ADD_WIDTH_FOR_LMS_LAYOUT = 150;

/**
 * # Hsedesign main menu
 */
interface MenueProps {
  className?: any;
}

export const Burger = styled(FlexBox)`
  height: 40px;
  align-items: center;
  opacity: 0.73;
  transition: all 0.2s;

  &:hover {
    opacity: 1;
  }
`;

export const LangContainer = styled(FlexBox)`
  //padding-left: 24px;
  //@media (min-width: 1440px) {
  //  padding-left: 37px;
  //}
  // @media(max-width: 1024px) {
  //   position: absolute;
  //   top: 50%;
  //   left: 50%;
  //   transform: translate(-50%, -50%);
  //   padding: 0;
  //   margin: 0 auto;
  // }
`;

export const DropdownWrapper = styled(FlexBox)`
  margin-left: 16px;

  @media (max-width: ${LayoutConst.screen.l_16}px) {
    margin-left: 4px;
  }

  @media (max-width: 940px) {
    margin-left: 0;
  }

  @media (max-width: 568px) {
    margin-left: 0;
  }
`;

export const HSEDeziignNavBar: FC<MenueProps> = () => {
  const auth = useAuth();
  const location = useLocation();
  const { t, i18n } = useTranslation();
  const history = useHistory();
  const theme = useTheme();
  const [visibleError, setVisibleError] = useState(false);
  const [{ mainBookId }] = useQueryState();
  const isSchool = AppTester.isSchool();
  const isProjectPreview = useRouteMatch<{ id: string }>("/preview/:id");
  const isCompetition = useRouteMatch<{ id: string }>("/competition/:id");
  const isBookPreview = useRouteMatch<{ id: string }>("/books/book-preview/:id");
  const isBookProjectPreview = useRouteMatch<{ id: string }>("/books/preview/:id");
  const isTeamPreview = useRouteMatch<{ id: string }>('/team-preview/:id');
  const isTeamLgPreview = useRouteMatch<{ id: string }>('/team-longread-preview/:id');
  const isCommdesign = location.pathname.startsWith("/school/commdesign") && AppTester.isSchool()
  const { teamName } = useParams<{ teamName: string }>();
  const isProfilePage = !!useRouteMatch("/designer");
  const isHSEMain = AppTester.isContext('hsedesign')
  const shouldNotSaveTeam = useMemo(() => isProfilePage && isHSEMain, [isProfilePage, isHSEMain])

  const team = useExternalOrganization(teamName, false, shouldNotSaveTeam) as Team | undefined;
  const MainLogo = useGetLogo({});

  const isChapterPreview = useMemo(() => (!!mainBookId && !!isBookProjectPreview), [mainBookId, isBookProjectPreview])

  const isLMS = AppTester.isLMSHSE() || team?.moderationType == ModerationType.LMS;

  const isBooks = !!useRouteMatch([LinkTo.hseBooks, '/hsebooks']);

  const profile = auth.token ? auth.associatedProfile : undefined;

  const isMobile = useIsMobile();
  const isTablet = useBreakpoint(1200);
  const toasts = useToasts()
  const isCompetitions = location.pathname.startsWith(LinkTo.awards);
  const isHseColors = AppTester.isHseColors();
  const isModer = useMemo(() => profile && bProfile.isModer(profile), [profile]);

  const [isFlexBoxEmpty, setIsFlexBoxEmpty] = useState(true);

  const {
    shouldDisplayCreateButton,
    shouldDisplayProDropdown,
    shouldDisplayChannelButton,
    shouldDisplayFeedButton,
    shouldDisplayLangSwitcher,
    shouldDisplayEditorInterface,
    shouldDisplayNotifications,
    createButtonTitle,
    onLangSwitch,
  } = useNavbarSettings();

  const shouldDisplaySearch = getShouldDisplaySearch()

  const isBriefModer = profile && profile.rolesList && Array.isArray(profile.rolesList)
    && (new ProfileRole(HsePolicies.access_brief_competitions)).containsIn(profile.rolesList);

  const isCompetitionModer = profile && profile.rolesList && Array.isArray(profile.rolesList)
    && (new ProfileRole(HsePolicies.access_competitions)).containsIn(profile.rolesList);

  if (shouldDisplayEditorInterface) {
    return null;
  }

  if (isCommdesign) return <CommdesignNavbar />

  if ((isMobile || isTablet)) {
    return <DeziignNavBarMobile />
  }

  const getHeaderNavLayout = (isCompetition: any, isSchool?: boolean, isFlexBoxEmpty?: boolean) => {
    if (isCompetition) {
      return <SectionCompetition isFlexBoxEmpty={isFlexBoxEmpty} key={'section-d'} />
    } else if (isSchool) {
      return <SectionSchool key={'section-d'} />
    } else {
      return <SectionDeziign team={team} isFlexBoxEmpty={isFlexBoxEmpty} key={'section-d'} />
    }
  }

  return (
    <NavBar
      errorComponent={visibleError && <BacklogModalView onExit={() => setVisibleError(false)} />}
      theming={{
        zIndex: 99999,
        backgroundColor: theme.navigationBar.backgroundColor,
        borderBottomColor: theme.navigationBar.borderBottomColor,
        backgroundScrolling: theme.navigationBar.backgroundScrollingColor,
        boxShadow: theme.navigationBar.boxShadow,
      }}
      logo={MainLogo}
      onLogoClick={() => {
        if (isProjectPreview) return

        window.location.href = '/'
      }}
      sections={[
        [getHeaderNavLayout(isCompetition, isSchool, isFlexBoxEmpty)],
        [
          <ChapterPager />,
          <ViewTypeControllerWide />,
          ...(shouldDisplaySearch ? [
            <MainSearchButton />
          ] : []),
          ...(isHseColors ? [
            <FlexBox offsetRight={isMobile ? 16 : 0}>
              <RectangularButtonFilled onClick={() => navigator.clipboard.writeText('79999999999').then(() => toasts.info(t && t('phone_copied')))}>
                <PhoneText style={{ color: Colors.geoWhite100 }}>
                  +7 999 999 99-99
                </PhoneText>
              </RectangularButtonFilled>
            </FlexBox>
          ] : []),
          ...(shouldDisplayNotifications) ? [
            <NotificationsController />,
            ...(shouldDisplayChannelButton ? [<ChannelButton />] : []),
            ...(shouldDisplayFeedButton ? [<FeedButton />] : []),
          ] : [],
          ...(shouldDisplayLangSwitcher ?
            [
              <LangContainer>
                <BLangSwitcher
                  currentLanguage={i18n.language}
                  onLangSelect={onLangSwitch}
                  key="lang"
                />
              </LangContainer>
            ] :
            []),

          ...((isProjectPreview || isBookPreview || isBookProjectPreview || isTeamPreview || isTeamLgPreview) ?
            [<FlexBox key="button-widget" align="center">
              <RectangularButtonHollow
                onClick={() => {
                  if (isChapterPreview && isBookProjectPreview?.params?.id) {
                    history.push(`/books/book-edit/${(mainBookId ?? 'undefined')}`)
                    return;
                  }
                  if (isProjectPreview?.params?.id)
                    history.push(CreateLinkTo.projectEdit(isProjectPreview?.params?.id ?? 'undefined'))
                  if (isBookPreview?.params?.id)
                    history.push(CreateLinkTo.bookEdit(isBookPreview?.params?.id ?? 'undefined'))
                  if (isBookProjectPreview?.params?.id)
                    history.push(CreateLinkTo.bookProjectEdit(isBookProjectPreview?.params?.id ?? 'undefined'))
                  if (isTeamPreview?.params?.id)
                    history.push(CreateLinkTo.teamEdit(isTeamPreview?.params?.id ?? 'undefined'))
                  if (isTeamLgPreview?.params?.id)
                    history.push(CreateLinkTo.teamEdit(isTeamLgPreview?.params?.id ?? 'undefined') + '?tab=lg')
                }
                }
              >
                {t("nav.exit_preview") ?? "Exit"}
              </RectangularButtonHollow>
            </FlexBox>
            ] :
            shouldDisplayCreateButton ? [<FlexBox
              key={'button-widget'} align={'center'}>
              {shouldDisplayProDropdown ? (
                <CreatePresentationButton />
              ) : (
                <NavbarButtonFilled
                  style={{ padding: '6px 24px', minWidth: 'auto', maxWidth: 'max-content', whiteSpace: 'nowrap', fontWeight: 700 }}
                  onClick={() => {
                    if (isCompetitions && (isModer || isBriefModer || isCompetitionModer)) {
                      history.push(CreateLinkTo.competitionCreate());
                    } else if (isBooks) {
                      history.push(CreateLinkTo.bookCreate());
                    } else if (isLMS) {
                      // @ts-ignore
                      history.push(CreateLinkTo.projectCreateByOrganization(team?.contextName));
                    } else {
                      history.push(CreateLinkTo.projectCreate());
                    }
                  }}
                >
                  {createButtonTitle ?? 'create'}
                </NavbarButtonFilled>
              )}
            </FlexBox>] : []),
          ...(isHseColors ? [] : [<WidgetLogin />]),
        ],
      ]}
    />
  );
};
// @ts-ignore
const SectionCompetition = ({ isFlexBoxEmpty }) => {
  const theme = useTheme();
  const isHseMain = AppTester.isContext('hsedesign');

  const isLMS = AppTester.isLMSHSE();
  const isStartHSE = AppTester.isStartHSE();
  const isProHse = AppTester.isProHSE();
  const is1600 = useBreakpoint(LayoutConst.screen.l_16 + ADD_WIDTH_FOR_HSEMAIN_LAYOUT);
  const isLmsSize = useBreakpoint(LayoutConst.screen.l_16 + ADD_WIDTH_FOR_LMS_LAYOUT);
  const isMac13ForHSEMAIN = useBreakpoint(LayoutConst.screen.mac13 + ADD_WIDTH_FOR_HSEMAIN_LAYOUT);
  const isFullHD = useBreakpoint(1920);
  const is1280 = useBreakpoint(LayoutConst.screen.l_12);
  const isSamokat = useRouteMatch("/samokat");

  const shouldDisplayDotsDropdown = useMemo(
    () => {
      if ((isLMS || isStartHSE) && isLmsSize) {
        return true;
      }
      if (isStartHSE && isFullHD) {
        return true;
      }
      return ((isHseMain || isProHse || isSamokat || isStartHSE) && is1600) || (!isFlexBoxEmpty && isFullHD)
    }
    , [isHseMain, is1600, isProHse, isLmsSize, isLMS, isFullHD, isFlexBoxEmpty, isSamokat, isStartHSE])

  const currentCutTabs = useMemo(() => {
    if ((isHseMain || isProHse || isSamokat || isStartHSE) && is1280) return 4;
    else if ((isHseMain || isProHse || isSamokat || isStartHSE) && is1600) return 5;
    else if ((isLMS || isStartHSE) && isMac13ForHSEMAIN) return 4;
    // else if (is1600) return 3;
    return 4;
  }, [isHseMain, isProHse, isSamokat, isMac13ForHSEMAIN, is1280, isLMS, is1600, isStartHSE])

  const fullUrls = useGetFilteredTabs()

  const formatForExternalLinks = fullUrls.slice(currentCutTabs).map(item => {
    return {
      active: item.active,
      ctx: "",
      external: item.external,
      isTeam: false,
      disabled: item.disabled,
      name: item.linkTo,
      title: item.content,
      value: item.linkTo
    }
  })

  const items = useMemo(() => {
    if (((isHseMain || isLMS || isProHse || isSamokat || isStartHSE) && is1600) || (isStartHSE && isFullHD)) {
      return fullUrls.slice(0, currentCutTabs)
    } else if ((isLMS || isStartHSE) && isLmsSize) {
      return fullUrls.slice(0, currentCutTabs)
    } else if ((isFlexBoxEmpty && !(isStartHSE && isFullHD)) || !isFullHD) {
      return fullUrls
    }

    return fullUrls.slice(0, currentCutTabs)
  }, [isHseMain, isMac13ForHSEMAIN, isProHse, isLMS, isSamokat, is1600, currentCutTabs, fullUrls, isFullHD, isFlexBoxEmpty, isStartHSE, isLmsSize])

  return (
    <>
      <NavbarWidget.Links
        key={'links-widget'}
        items={items}
        theming={theme.navigationBar.links}
      />
      {shouldDisplayDotsDropdown && !!formatForExternalLinks?.length && (
        <DropdownWrapper>
          <DropdownWithExternalsLinks
            maxHeight={460}
            maxWidth={400}
            list={formatForExternalLinks}
            initialTab={''}
            hoverOpen
          />
        </DropdownWrapper>
      )}
    </>
  );
}

// @ts-ignore
const SectionDeziign = ({ team, isFlexBoxEmpty }) => {
  const theme = useTheme();
  const is1280 = useBreakpoint(LayoutConst.screen.l_12);
  const isFullHD = useBreakpoint(1920);
  const is1600 = useBreakpoint(LayoutConst.screen.l_16 + ADD_WIDTH_FOR_HSEMAIN_LAYOUT);
  const isMac13ForHSEMAIN = useBreakpoint(LayoutConst.screen.mac13 + ADD_WIDTH_FOR_HSEMAIN_LAYOUT);
  const isLmsSize = useBreakpoint(LayoutConst.screen.l_16 + ADD_WIDTH_FOR_LMS_LAYOUT);
  const { anchorsOverrideNavigation } = useSelector(HseContextSelector);

  const isProHse = AppTester.isProHSE();
  const isHseMain = AppTester.isContext('hsedesign');
  const isExams = AppTester.isExamHSE();
  const isSamokat = useRouteMatch("/samokat");
  const isLMS = AppTester.isLMSHSE();
  const isStartHSE = AppTester.isStartHSE();
  const isBooks = !!useRouteMatch([LinkTo.hseBooks, '/hsebooks']);

  const fullUrls = useGetFilteredTabs()

  const shouldDisplayDotsDropdown = useMemo(
    () => {
      if (((isLMS || isStartHSE || isExams) && isLmsSize) || (!isFlexBoxEmpty && isFullHD)) {
        return true;
      }
      if (isStartHSE && isFullHD) {
        return true;
      }

      return ((isHseMain || isProHse || isSamokat || isStartHSE || isExams) && is1600) || (!isFlexBoxEmpty && isFullHD)
    }
    , [isHseMain, is1600, isProHse, isLMS, isLmsSize, isFullHD, isFlexBoxEmpty, isExams, isSamokat, isStartHSE])

  const currentCutTabs = useMemo(() => {
    if (isBooks && isMac13ForHSEMAIN) return 3;
    else if (isBooks && is1600) return 4;
    else if ((isLMS || isStartHSE) && (isMac13ForHSEMAIN || isLmsSize)) return 4;
    else if (isLMS) return 7;
    else if (isStartHSE && isFullHD) return 4;
    else if (isStartHSE) return 8;
    else if (isExams && isMac13ForHSEMAIN) return 3
    else if ((isHseMain || isProHse || isSamokat || isStartHSE || isExams) && is1280) return 4;
    else if ((isHseMain || isProHse || isSamokat || isStartHSE || isExams) && is1600) return 5;
    // else if (is1600) return 3;
    return 4;
  }, [isHseMain, isProHse, isSamokat, isExams, isLmsSize, isBooks, isMac13ForHSEMAIN, is1280, isLMS, is1600, isStartHSE, isFullHD])


  const formatForExternalLinks = fullUrls.slice(currentCutTabs).map(item => {
    return {
      active: item.active,
      action: item.action,
      ctx: "",
      external: item.external,
      isTeam: false,
      isModal: true,
      disabled: item.disabled,
      name: item.linkTo,
      title: item.content,
      value: item.linkTo
    }
  })

  const items = useMemo(() => {
    if (((isHseMain || isProHse || isSamokat || isStartHSE || isExams) && is1600) || (isStartHSE && isFullHD)) {
      return fullUrls.slice(0, currentCutTabs)
    } else if ((isLMS || isStartHSE || isExams) && isLmsSize) {
      return fullUrls.slice(0, currentCutTabs)
    }
    else if ((isFlexBoxEmpty && !(isStartHSE && isFullHD)) || !isFullHD) {
      return fullUrls
    }

    return fullUrls.slice(0, currentCutTabs)
  }, [isHseMain, isMac13ForHSEMAIN, isProHse, isExams, isLmsSize, isLMS, isSamokat, is1600, currentCutTabs, fullUrls, isFullHD, isFlexBoxEmpty, isStartHSE])


  if (anchorsOverrideNavigation) {
    return <AnchorNavigation />
  }

  return (
    <>
      <NavbarWidget.Links
        key="links-widget"
        theming={theme.navigationBar.linksHse}
        items={items}
      />
      {shouldDisplayDotsDropdown && !!formatForExternalLinks?.length && (
        <DropdownWrapper>
          <DropdownWithExternalsLinks
            maxHeight={460}
            maxWidth={400}
            list={formatForExternalLinks}
            initialTab={''}
            hoverOpen
          />
        </DropdownWrapper>
      )}
    </>
  );
};


const SectionSchool = () => {
  const theme = useTheme();
  const items = useGetFilteredTabs()

  return (
      <NavbarWidget.Links
        key="links-widget"
        theming={theme.navigationBar.linksHse}
        items={items}
      />
  );
};
